// extracted by mini-css-extract-plugin
export default {"subtitle":"customize__subtitle","includes":"customize__includes","icon":"customize__icon","light":"customize__light","content":"customize__content","compare":"customize__compare"};